var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row items-center"},[_c('div',{staticClass:"q-mr-lg",class:[_vm.justifyBetween ? 'col' : 'col-shrink']},[_c('WebbymizeLogo',{attrs:{"to":{ name: _vm.ENUMS.ROUTES.AUTH.SIGNIN },"show-switcher":""}})],1),_c('div',{staticClass:"col",class:{'flex justify-end': _vm.justifyBetween}},[_c('LanguageSelector')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }